import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function dateOfBirthValidator(
  minAge: number = 17,
  minYear: number = 1900
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const birthDate = new Date(control.value);
    const today = new Date();

    // Check for valid date
    if (isNaN(birthDate.getTime())) {
      return { invalidDate: true };
    }

    const birthYear = birthDate.getFullYear();

    // Too old (year before 1900)
    if (birthYear < minYear) {
      return { tooOld: { minYear, actualYear: birthYear } };
    }

    // Calculate age
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    // Under 17
    if (age < minAge) {
      return { underage: { requiredAge: minAge, actualAge: age } };
    }

    return null;
  };
}
